











































import { Vue, Component } from 'vue-property-decorator';
import Bus from '@/common/util/bus';
import store from '@/vuex/index';
@Component({
    components: {},
})
export default class SideBar extends Vue {
    public collapsed: boolean = false;
    public admin: boolean = false;
    public userName: string = '';
    public enterpriseLogoImgUrl: string = '';

    public mounted() {
        // this.$store.dispatch('rongCloud/getNumber');
        this.$root.$on('foldFunc', (data) => {
            this.collapsed = data;
        });
    }
    get activeMenu() {
        // const route = this.$route;
        // const { meta, path } = route;
        // if (meta.activeMenu) {
        //     return meta.activeMenu
        // }
        // return path;
        console.log(11111111111111111111111111111);
        
        return this.$route.meta.guidePath ? this.$route.meta.jumpPath : this.$route.path;
    }
    get sycount() {
        return this.$store.state.rongCloud.causeAuditCount;
    }
    get ylcount() {
        return this.$store.state.rongCloud.advanceAuditCount;
    }
    get bxcount() {
        return this.$store.state.rongCloud.reimburseAuditCount;
    }
    get apcount() {
        return this.$store.state.rongCloud.advanceToPayCount;
    }
    clear() {
        sessionStorage.clear();
    }
    collapsedfun() {
        this.collapsed = !this.collapsed;
    }
}
